<template>
  <div>
    <div>
      <div class="am-Conversion-icons">
        <a @click="addConversion()" title="Add Conversion"><svg-icon icon="add" title="Add Conversion" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon></a>
      </div>
      <table class="am-Conversion">
        <thead>
        <tr>
          <th class="am-void" v-if="isAllowedVoid">V</th>
          <th @click="sort('conversionType')">Type<span><img v-if="sortData.currentSort === 'conversionType'" :src="sorterArrow"></span></th>
          <th @click="sort('competitorName')">Competitor System<span><img v-if="sortData.currentSort === 'competitorName'" :src="sorterArrow"></span></th>
          <th @click="sort('conversionFee','currency')">Conversion Fee<span><img v-if="sortData.currentSort === 'conversionFee'" :src="sorterArrow"></span></th>
          <th @click="sort('insertDate')">Date Requested<span><img v-if="sortData.currentSort === 'insertDate'" :src="sorterArrow"></span></th>
          <th @click="sort('completeDate')">Date Completed<span><img v-if="sortData.currentSort === 'completeDate'" :src="sorterArrow"></span></th>
          <th>Comments</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="conversion in pageConversionList">
          <td class="am-void" v-if="isAllowedVoid && conversion.voidDate === null" @click="confirmConversion(conversion)"><a><svg-icon icon="void" class="am-glyphicon-medium am-glyphicon-blue" title="Void"/></a></td>
          <td class="alignment" v-if="isAllowedVoid && conversion.voidDate !== null"></td>
          <td v-bind:class="{ voided: conversion.voidDate !== null }">{{conversion.conversionType}}</td>
          <td v-bind:class="{ voided: conversion.voidDate !== null }">{{conversion.competitorName}}</td>
          <td v-bind:class="{ voided: conversion.voidDate !== null, alignment : true }">${{conversion.conversionFee}}</td>
          <td v-bind:class="{ voided: conversion.voidDate !== null }">{{getDateRequested(conversion)}}</td>
          <td v-bind:class="{ voided: conversion.voidDate !== null }">{{getDateCompleted(conversion)}}</td>
          <td v-bind:class="{ voided: conversion.voidDate !== null, truncate: true }" :title="conversion.comments">{{conversion.comments}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="am-conversion-pagination" v-show="conversionList.length > pageSize">
      <pagination :allData="conversionList" :pageSize="pageSize" :sortData="sortData" @setPageData="setPageData"></pagination>
    </div>
    <modal name="conversionModal" classes="am-vue-modal" width="500px"  :pivotY="0.3" height="auto" :clickToClose="false" :adaptive="true"  :reset="true">
      <conversion-modal :masterId="masterId"></conversion-modal>
    </modal>
    <modal name="ConversionPopUp" classes="am-vue-modal" :clickToClose="false" height="auto" width="370px" :scrollable="true"  :pivotY="0.3" :adaptive="true">
      <message-popup :confirmDelete="true" @CloseModal="voidConversion" modal-name="ConversionPopUp" :errors="messageString" messageHeader="Confirmation"></message-popup>
    </modal>
  </div>
</template>

<script>
  import pagination from '@/components/pagination/pagination.vue'
  import ConversionModal from "./ConversionModal"
  import sort from '@/mixins/tableSorter'
  import MessagePopup from './MessagePopup'
  import api from "../http";

  export default {

    name: "Conversion",
    data() {
      return {
        name: 'conversionTab',
        isAllowedVoid: 0,
        editRow: {},
        hideModalData: {},
        pageSize: 15,
        pageConversionList: [],
        messageString: 'Are you SURE you want to void this conversion?',
        voidConversionId: null,
        pageList: [],
        conversionList: []
      }
    },

    components: {
      ConversionModal,
      pagination,
      MessagePopup,
      'addConversion': ConversionModal,
    },
    mixins: [sort],

    props: {
      masterId: {
        type: Number,
        default: 0
      }
    },

    mounted() {
      this.loadConversions()
    },

    methods: {
      setPageData (data) {
        this.pageConversionList = data
      },
      addConversion: function () {
        this.$modal.show('conversionModal')
      },
      closeConversionModal: function () {
        this.$modal.hide('conversionModal')
        document.body.style.overflow = "";
      },
      getDateRequested (conversion) {
        return (conversion.insertDate !== null) ? moment(conversion.insertDate).format('MM/DD/YYYY') : "";
      },
      getDateCompleted (conversion) {
        return (conversion.completeDate !== null) ? moment(conversion.completeDate).format('MM/DD/YYYY') : "";
      },
      confirmConversion (conversion) {
        this.voidConversionId = conversion.conversionsRequestedId
        return this.$modal.show('ConversionPopUp')
      },
      voidConversion () {
        let self = this
        if( self.voidConversionId !== null) {
          return api.makeRequest('/backoffice/conversion/'+ self.voidConversionId +'/void/' + self.masterId).then(
            (data) => {
              self.voidConversionId = null
              window.location.reload()
              return true
            }
          )
        } else {
          return false
        }
      },
      async loadConversions() {
        this.$log.log('Conversion-Log')
        try {
          let response = await api.authenticated().then((authStore) => {
            return api.makeRequest('/backoffice/conversion/'+ authStore.user.id +'/list/' + this.masterId)
          })

          this.$log.log('Conversion-Log', response)
          this.isAllowedVoid = response.data.isAllowedVoid
          this.conversionList = response.data.results
        } catch (error) {
          this.$log.log('Conversion-Log-Failure', error)

          this.conversionList = []
          this.isAllowedVoid = false
        }
      }
    }
  }
</script>

<style scoped>
  .am-Conversion {
    width: 100%;
  }
  .am-Conversion-icons {
    float: right;
    cursor: pointer;
  }
  .am-Conversion td{
    border-top: 1px solid #ddd;
    height: 25px;
  }

  .am-Conversion th{
    padding-bottom:5px;
    cursor: pointer;
  }
  .am-Conversion thead{
    color: white;
    background-color: #444444;
  }

  .am-Conversion>tbody>tr:nth-child(odd)>td, .am-Conversion>tbody>tr:nth-child(odd)>th {
    background-color: #f9f9f9;
  }
  .am-conversion-pagination {
    padding: 15px 12px 0px 0px;
    margin: auto;
    text-align: center;
  }
  .am-void {
    text-align: center;
  }
  .v--modal-overlay {
    background-color: rgba(0,0,0,0.6) !important;
  }
  .voided {
    color:red;
  }
  .alignment {
    text-align: left
  }
  .truncate {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
